export const UPDATE_QUESTIONAIRE_CATEGORY = "UPDATE_QUESTIONAIRE_CATEGORY"
export const UPDATE_QUESTIONAIRE_CATEGORY_SUCCESSFUL =
  "UPDATE_QUESTIONAIRE_CATEGORY_SUCCESSFUL"
export const UPDATE_QUESTIONAIRE_CATEGORY_FAILED =
  "UPDATE_QUESTIONAIRE_CATEGORY_FAILED"
export const UPDATE_QUESTIONAIRE_CATEGORY_RESET =
  "UPDATE_QUESTIONAIRE_CATEGORY_RESET"
